import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types/news";

interface BreakingTickerProps {
  articles: NewsArticle[];
}

function BreakingTicker({ articles }: BreakingTickerProps) {
  if (articles.length === 0) {
    return null;
  }
  const loop = [...articles, ...articles];

  return (
    <div className="bg-foreground-950 dark:bg-background-50 text-background-50 dark:text-foreground-950">
      <div className="w-full flex items-stretch">
        <div className="shrink-0 flex items-center gap-2 px-4 md:px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950">
          <span className="w-2 h-2 rounded-full bg-background-50 dark:bg-foreground-950 animate-live" />
          <span className="font-heading text-sm font-bold whitespace-nowrap tracking-wide">突发快讯</span>
        </div>

        <div className="relative flex-1 overflow-hidden flex items-center">
          <div className="flex items-center gap-10 animate-ticker whitespace-nowrap will-change-transform">
            {loop.map((article, idx) => (
              <Link
                key={`${article.id}-${idx}`}
                to={`/article/${article.id}`}
                className="flex items-center gap-3 text-sm text-background-100 dark:text-foreground-800 hover:text-accent-300 transition-colors cursor-pointer"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 shrink-0" />
                <span className="font-medium">{article.title}</span>
                <span className="text-background-400 dark:text-foreground-600 text-xs">{article.publishedAt}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BreakingTicker;